import Header from "./Header";
import Footer from "./Footer";
import ChatBot from "./ChatBot";
import UserQueries from "./UserQueries";
import "../styles/Faq.css";
import { FaQuestionCircle, FaHistory, FaShieldAlt } from "react-icons/fa";

export default function Faq() {
  return (
    <div className="jus-faq-container">
      <Header />

      {/* HERO SECTION */}
      <section className="jus-faq-hero">
        <div className="jus-faq-hero-content">
          <div className="jus-faq-hero-badge">
            <FaQuestionCircle />
            <span>Help & Support</span>
          </div>

          <h1 className="jus-faq-hero-title">
            Frequently Asked <span className="jus-faq-highlight">Questions</span>
          </h1>

          <p className="jus-faq-hero-subtitle">
            Clear answers to common questions about Justivon, our services,
            privacy, security, and platform usage.
          </p>

          <div className="jus-faq-hero-meta">
            <div className="jus-faq-meta-item">
              <FaHistory />
              <span>Updated Regularly</span>
            </div>
            <div className="jus-faq-meta-item">
              <FaShieldAlt />
              <span>Trusted & Transparent</span>
            </div>
          </div>
        </div>

        <div className="jus-faq-hero-pattern"></div>
      </section>
      <UserQueries />
      <ChatBot />
      <Footer />
    </div>
  );
}
